const logToOverlay = (message) => {
    const loadingOverlay = document.getElementById('loadingOverlay');
    if (loadingOverlay) {
        // Replace newline characters with <br> tags
        const formattedMessage = message.replace(/\n/g, '<br>');
        loadingOverlay.innerHTML = formattedMessage;
    }
};

function formatMinutesAsTime(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Pad with zeros to ensure two digits
    const hoursStr = hours.toString().padStart(2, '0');
    const minutesStr = minutes.toString().padStart(2, '0');

    return `${hoursStr}:${minutesStr}`;
}

export { logToOverlay, formatMinutesAsTime };
